import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
  pendingApproval: [],
  pendingApprovalPagination: []
}

const LicensesModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default LicensesModule